import React from 'react';
import PostList from './PostList';

const App = () => (
  <div className="ui container">
    <PostList />
  </div>
);

export default App;
